<template>
	<div class="sf-datatable-wrapper">
		<sf-data-table
			ref="dataTable"
			index
			:scrId="scrId"
			paging
			:columns="columns"
			:rows="rows"
			:stripe="false"
			@changedPage="changedPage"
			style="height: 260px"
		>
		</sf-data-table>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/ceqi/CmpnMst/store/helpers';
export default {
	props: { scrId: { type: String, default: '' } },
	data() {
		return {};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.popUpOpCdList;
		},
		columns() {
			return [
				{
					label: '* ' + this.getMessage_('QWCC001096'), //op코드
					prop: 'opCd',
					minWidth: '90px',
					sortable: false,
					highlight: true,
					clickEvent: this.clickOpCd
				},
				{
					label: '* ' + this.getMessage_('QWCC001807'), //op코드명
					prop: 'opNm',
					minWidth: '150px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001100'), //LTS
					prop: 'lts',
					minWidth: '90px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001040'), // 부품가격
					prop: 'asCst',
					minWidth: '100px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001102'), // 공임비
					prop: 'wags',
					minWidth: '100px',
					sortable: false
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async clickOpCd(row) {
			await this.setOpCdPopupSearchInit_();
			await this.$emit('selectOpCd', row);

			// if (row.partNoCount == 0) {
			// 	//교환부품수량이 존재하지 않는 캠페인입니다
			// 	this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001872') });
			// } else {
			// 	const cmpnNm = row.cmpnNm;
			// 	const cmpnNo = row.cmpnNo;

			// 	this.$sf_toggleLoading(true);
			// 	await this.setState_({ key: 'selectedCmpnNm', value: cmpnNm });
			// 	await this.getCmpnMstPopList_(cmpnNo).finally(() => this.$sf_toggleLoading(false));
			// }
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				// return;
			}

			this.setPopUpPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPopUpPagingInfo_({ key: 'pageUnit', value: pageUnitVal });

			this.$emit('Refresh', currentPageVal, pageUnitVal);
		}
	}
};
</script>
